import React, { useEffect, useState } from 'react';
import { Flex, Title } from '@cognite/cogs.js';
import styled from 'styled-components/macro';
import { SchemaCollection } from 'types/dt-graphql-apollo-v2';
import { Spinner } from 'components';
import { useGetProjectQuery } from 'hooks/projects';
import { parseRefId } from 'utils/misc';
import { GraphqlCodeEditor } from '../components/GraphqlCodeEditor';

export const SchemaView = ({ schema }: { schema: SchemaCollection }) => {
  const [savedSchema, setSavedSchema] = useState('');

  const { data, loading } = useGetProjectQuery(schema.refId);

  const parsedRefId = parseRefId(schema.refId);

  useEffect(() => {
    if (data?.Project && data.Project[0]?.graphQLSchemaString) {
      const schemaCollection = data.Project[0]?.graphQLSchemaString;
      if (schemaCollection) {
        setSavedSchema(schemaCollection);
      }
    }
  }, [data]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <StyledWrapper>
      <StyledEditor>
        <StyledTop>
          <StyledEditorTitle>
            <Title level={4}>Schema</Title>
          </StyledEditorTitle>
        </StyledTop>
        {savedSchema && <GraphqlCodeEditor code={savedSchema} />}

        {!savedSchema && (
          <Flex direction="column" gap={8}>
            <span>
              Could not find a data model with the following properties:
            </span>

            <Flex direction="column">
              <div>
                Space: <b>{parsedRefId.space}</b>
              </div>
              <div>
                External Id: <b>{parsedRefId.dataModel}</b>
              </div>
              <div>
                Version: <b>{parsedRefId.dataModelVersion}</b>
              </div>
            </Flex>
          </Flex>
        )}
      </StyledEditor>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  display: flex;
  overflow: auto;
  flex: 1;
`;

const StyledEditor = styled.div`
  flex: 2;
  overflow: auto;
  padding: 0 3rem;
  overflow: hidden;
  background-color: var(--cogs-greyscale-grey1);

  section {
    height: calc(100vh - 250px) !important;
  }
`;

const StyledTop = styled.div`
  display: flex;
  padding: 2rem 0 2rem 0;
`;

const StyledEditorTitle = styled.div`
  flex: 1;
  align-self: center;
`;
